module.exports = __webpack_public_path__ + "img/win.79f176c4.png";